import { ACCESS_SERVICE_PLUGIN_TOKEN } from '@core/shared/access';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class PaymentReminderBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/payment-reminder/feature","featureId":"common-payment-reminder"},
      bundledItemModels: ["PaymentReminderItem", "PaymentReminderInteractionItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'PaymentReminderFrontendFeature'
      },
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'PaymentReminderFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PaymentReminderFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'PaymentReminderBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PaymentReminderBackendAdminFeature'
      }],
      providers: [{
        forPlatform: 'frontend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessPaymentReminderFrontendPlugin',
        importFrom: 'frontend'
      }, {
        forPlatform: 'backend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessPaymentReminderBackendPlugin',
        importFrom: 'backend'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {},
        admin: {
          'payment-reminder': id => {
            return ['/payment-reminder', id];
          },
          'payment-reminder-manager': childPath => {
            return ['/payment-reminder', childPath];
          }
        }
      }
    };
  }
}